package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BulkActionRequest(
    val items: List<BulkActionItem>,
    val action: BulkActionKind,
    val reason: String? = null,
    @SerialName("duration_days") val durationDays: Int? = null,
)

@Serializable
data class BulkActionItem(
    val type: BulkActionItemType,
    val id: String,
)

@Serializable
enum class BulkActionItemType {
    @SerialName("listing_report") LISTING_REPORT,
    @SerialName("user_report") USER_REPORT,
    @SerialName("listing") LISTING,
}

@Serializable
enum class BulkActionKind {
    @SerialName("dismiss") DISMISS,
    @SerialName("suspend_listing") SUSPEND_LISTING,
    @SerialName("warn_user") WARN_USER,
    @SerialName("suspend_user") SUSPEND_USER,
    @SerialName("ban_user") BAN_USER,
}
